import { useProjectSetupId } from "../../navigation/projectSetups";
import { projectSetupsApi } from "../../services/api/projectSetups";
import FileListTabPage from "../files/FileListTabPage";

export default function ProjectSetupFilesTabPage() {
    return <FileListTabPage api={projectSetupsApi.files} ownerId={useProjectSetupId()} />;
}
